module.exports = (state, action) => {
  const { id } = action.payload
  if (state.labels[id]) {
    state.labels[id].showninfeed = !state.labels[id].showninfeed
  }
}
